import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  QtestProjectNameField,
  validateQtestProjectName,
} from './QtestProjectNameField';

export const QtestProjectNameFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension<string>({
    name: 'QtestProjectName',
    component: QtestProjectNameField,
    validation: async (data, validation, context) => {
      await validateQtestProjectName(data, validation, context);
    },
  }),
);
